import state from './moduleGiftState.js'
import mutations from './moduleGiftMutations.js'
import actions from './moduleGiftAction.js'
import getters from './moduleGiftGetters.js'

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
